import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalAddFamily2 from "./ModalAddFamily2";

const useModalAddFamily = ( onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, mode: 'none', child_id: null, family_id: null })  ;

    const onClickActivate = ( newMode, child_id, family_id ) =>
    {
        switch ( newMode )
        {
            case 'delete':
                setDialog ({ openState: true, child_id: child_id, family_id: family_id, mode: 'delete'});
                break ;
            case 'create':
                setDialog ({ openState: true, child_id: child_id, family_id: family_id, mode: 'create'});
                break ;
            case 'edit':
                setDialog ({ openState: true, child_id: child_id, family_id: family_id,  mode: 'edit'});
                break ;
        }
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, user_id: null, key: null, mode: 'none'});
    };

    const onSaveComplete = ( key ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, user_id: null, mode: 'none'});

        // Tell the parent we're done
        onSaveCompleted( key ) ;
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalAddFamily2 child_id={dialog.child_id} family_id={dialog.family_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode} /> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalAddFamily ;
